import { Stack } from '@mui/system';
import AccountMenu from '../accountMenu/accountMenu';
import HelpMenu from '../helpMenu/helpMenu';
import NotificationsMenu from '../notificationsMenu/notificationsMenu';
import SettingsMenu from '../settingsMenu/settingsMenu';
import { LanguageSwitcher } from 'components/containers';

export default function ToolbarTrayMenu() {
  return (
    <Stack direction="row" justifyContent="center" alignItems="center">
      <NotificationsMenu />
      <HelpMenu />
      <SettingsMenu />
      <AccountMenu />
      {/*<LanguageSwitcher />*/}
    </Stack>
  );
}
